import PublishOn from '../components/publishOn';
import HeaderNavigation from './headerNavigation';
import MenuBackground from './menuBackground';
import MenuTabs from './menuTabs';
import MenuTabsContent from './menuTabsContent';
import TabUnderline from '../components/tabUnderline';

export default [
  HeaderNavigation,
  MenuBackground,
  TabUnderline,
  MenuTabsContent,
  MenuTabs,
  PublishOn,
];
